// extracted by mini-css-extract-plugin
export default {"root":"Kd6R9N","list":"NT9PPl","footer":"rVhHpl"};